import type { FC } from 'react';
import { useStore } from 'zustand';

import { Modal as SBModal } from '@motorway/motorway-storybook-cra';

import { modalService, ModalStore } from 'Features/SellerCommunications/services';

import { ModalRouter } from './ModalRouter';

import styles from './Modal.module.scss';

export const Modal: FC = () => {
	const { isOpen } = useStore(ModalStore);

	return isOpen ? (
		<SBModal
			contentClass={styles.modalContent}
			dialogClass={styles.modalDialog}
			dismissModal={modalService.onClose}
			shouldCloseOnEsc={false}
			shouldCloseOnOverlayClick={false}
			size="large"
		>
			<ModalRouter />
		</SBModal>
	) : null;
};
